import { render } from "./Trade.vue?vue&type=template&id=88290c20"
import script from "./Trade.vue?vue&type=script&lang=js"
export * from "./Trade.vue?vue&type=script&lang=js"

import "./Trade.vue?vue&type=style&index=0&id=88290c20&lang=css"
script.render = render

export default script